import { render, staticRenderFns } from "./ResearchRegionTrack.vue?vue&type=template&id=f8ed5438"
import script from "./ResearchRegionTrack.vue?vue&type=script&lang=js"
export * from "./ResearchRegionTrack.vue?vue&type=script&lang=js"
import style0 from "./ResearchRegionTrack.vue?vue&type=style&index=0&id=f8ed5438&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ed5438')) {
      api.createRecord('f8ed5438', component.options)
    } else {
      api.reload('f8ed5438', component.options)
    }
    module.hot.accept("./ResearchRegionTrack.vue?vue&type=template&id=f8ed5438", function () {
      api.rerender('f8ed5438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchRegionTrack.vue"
export default component.exports